import PropTypes from 'prop-types';

export const CardTypes = {
  tenant: PropTypes.string,
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string,
  }),
  previewText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  target: PropTypes.string,
  fromPrice: PropTypes.bool,
  productPrice: PropTypes.number,
  productSalePrice: PropTypes.number,
  productPriceDefinition: PropTypes.string,
  badgeText: PropTypes.string,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      badgeIcon: PropTypes.string,
      badgeColour: PropTypes.string,
      badgeTextColour: PropTypes.string,
    })
  ),
  dateString: PropTypes.string,
  blogCategory: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  type: PropTypes.string,
  isAffiliate: PropTypes.bool,
  affiliateLogo: PropTypes.string,
  hasResourceId: PropTypes.bool,
  ctaButtonText: PropTypes.string,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  postDate: PropTypes.string,
  hidePrice: PropTypes.bool,
};

export const CardsTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape(CardTypes)).isRequired,
  fetchStatus: PropTypes.string.isRequired,
  emptyState: PropTypes.node,
  cardAttrs: PropTypes.shape({
    className: PropTypes.string,
    hidePrice: PropTypes.bool,
  }),
};

export const FilterTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
  onChange: PropTypes.func,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const CartFilterTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape(FilterTypes)),
  cards: PropTypes.arrayOf(PropTypes.shape(CardTypes)),
  fetchStatus: PropTypes.string,
  emptyState: PropTypes.node,
  cardAttrs: PropTypes.shape({
    className: PropTypes.string,
    hidePrice: PropTypes.bool,
  }),
  cardsFilterTitle: PropTypes.string,
  filterPosition: PropTypes.string,
  pagination: PropTypes.shape({
    page: PropTypes.number,
    perPage: PropTypes.number,
    total: PropTypes.number,
    onChange: PropTypes.func,
  }),
  moreLink: PropTypes.node,
};

export const BadgesTypes = {
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      badgeIcon: PropTypes.string,
      badgeColour: PropTypes.string,
      badgeTextColour: PropTypes.string,
    })
  ),
};
